import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './locales/de.json';
import en from './locales/en.json';

const stored = (typeof localStorage !== 'undefined' && localStorage.getItem('lang')) || 'de';

void i18n.use(initReactI18next).init({
  resources: {
    de: { translation: de },
    en: { translation: en },
  },
  lng: stored === 'en' ? 'en' : 'de',
  fallbackLng: 'de',
  interpolation: { escapeValue: false },
});

export function setLanguage(lang: 'de' | 'en'): void {
  void i18n.changeLanguage(lang);
  localStorage.setItem('lang', lang);
  document.documentElement.lang = lang;
}

export default i18n;
